import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { AbstractReportComponent } from '../abstract.report.component';
import { DealerContact, DealerLContactResult } from '../models/dealer.contact.interface';
import { NgForm } from '@angular/forms';
import { Dealer } from '../../shared/models/dealer.interface';
import { MonthType } from '../../shared/models/month.type.interface';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DealerService } from '../../dealer/services/dealer.service';
import { FileService } from '../../shared/services/file.service';
import { ReportService } from '../services/report.service';
import { DeviceDetectorService } from 'ngx-device-detector';

export interface DealerContactParameterData {
  dealerContact: DealerContact;

  dealers: Dealer[];
  years: number[];
  months: MonthType[];
}

@Component({
  selector: 'app-dealer-contact',
  templateUrl: './dealer-contact.component.html',
  styleUrls: ['./dealer-contact.component.scss']
})
export class DealerContactComponent extends AbstractReportComponent implements OnInit {

  report: DealerLContactResult = null;
  parameters: DealerContact = {
    dealer_ID: null,
    year: null,
    startMonth: 0,
    endMonth: 11,
    startYear: null,
    endYear: null
  } as DealerContact;

  dealer: Dealer;

  dealers: Dealer[];

  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    dialog: MatDialog, private dealerService: DealerService, private fileService: FileService, private reportService: ReportService) {
    super(locale, dialog, deviceDetectorService);
  }

  ngOnInit() {
    this.dealerService.getList()
      .subscribe({
        next: (data) => {
          this.dealers = data;
          this.showParameters();
        },
        error: (error: string) => this.onError(error)
      });

    this.setupDates();
  }

  renderReport() {
    this.getReportFormat()
      .subscribe(formatData => {
        if (formatData == null) return;

        this.isRequesting = true;

        this.dealerService.getDealerContactExport(this.parameters, formatData.format)
          .subscribe({
            next: (data) => {
              this.isRequesting = false;
              this.fileService.downloadFile(data, 'DealerContact' + formatData.extension);
            },
            error: (error: string) => this.onError(error)
          });
      });
  }

  showParameters() {
    // wait until dropdowns loaded
    if (this.dealers == null)
      return;

    const dialogRef = this.dialog.open(DealerContactParameterDialog, {
      width: '550px',
      data: {
        dealerContact: (<any>Object).assign({}, this.parameters),

        dealers: this.dealers,
        years: this.years,
        months: this.months

      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.parameters = result.dealerContact as DealerContact;
        if (this.parameters.year == null || this.parameters.year.toString() == "null") {
          this.parameters.startYear = Math.min(...this.years);;
          this.parameters.endYear = Math.max(...this.years);
        }
        else {
          this.parameters.startYear = null;
          this.parameters.endYear = null;
        }

        this.reportService.setupParameters(this.parameters);

        this.dealer = this.dealers.find(s => s.dealer_ID == this.parameters.dealer_ID);

        this.dealerService.getDealerContactReport(this.parameters)
          .subscribe({
            next: (data) => {
              this.report = data;
            },
            error: (error: string) => this.onError(error)
          });
      }
    });
  }
}

@Component({
  selector: 'dealer.contact.parameter.dialog',
  templateUrl: 'dealer.contact.parameter.dialog.html',
})

export class DealerContactParameterDialog {

  constructor(
    public dialogRef: MatDialogRef<DealerContactParameterDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DealerContactParameterData) { }

  runReport(form: NgForm): void {
    if (form.valid) {
      this.dialogRef.close(this.data);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
